import { useReportingContext } from '@views/pages/Reporting/Reports/context';
import { SyntheticEvent, useState } from 'react';
import {
  useFoldersShortQuery,
  useOrganizationsShortQuery,
} from '@common/cache';
import { debounce } from '@util/debounce.ts';
import { ReportFilters, reportTypeOptions } from '../types.ts';
import { useReportTableDataGridStore } from '@store';

export const useReportTableFilters = () => {
  const { handleFilterChange, filters, handleResetFilters } =
    useReportingContext();

  const { density, setDensity } = useReportTableDataGridStore();

  const { data: foldersNameList = [] } = useFoldersShortQuery();
  const { data: organizationList = [] } = useOrganizationsShortQuery();

  const [search, setSearch] = useState(filters.search);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearch(newValue);

    debounce(() => handleFilterChange({ search: newValue }), true, 500);
  };

  const handleSelectFolder = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      report_folder_id: value?.id,
    });
  };

  const handleSelectOrg = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      organization_id: value?.id,
    });
  };

  const handleSelectType = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      report_type: value?.id as ReportFilters['report_type'],
    });
  };

  const resetFilters = () => {
    handleResetFilters();
    setSearch('');
  };

  const typeOptions = reportTypeOptions.map(o => ({
    id: o.value,
    name: o.label,
  }));

  return {
    folderOptions: foldersNameList,
    handleSelectFolder,
    folder:
      foldersNameList.find(item => filters.report_folder_id === item.id) ??
      null,
    org:
      organizationList.find(item => filters.organization_id === item.id) ??
      null,
    report_type:
      typeOptions.find(item => filters.report_type === item.id) ?? null,
    typeOptions,
    handleSelectOrg,
    handleSelectType,
    organizationOptions: organizationList,
    resetFilters,
    handleSearchChange,
    search,
    density,
    handleDensityChange: setDensity,
  };
};
